import { TResponseApi } from "../../vendors/@types/httpApi";
import {
  DuvidaFrequentePage,
  DuvidaFrequenteParams,
} from "../shared/@types/duvidaFrequente";
import { publicApi } from "../shared/apis/api";

export default class DuvidaFrequenteService {
  private readonly rota = "duvida-frequente";

  public consultar(
    params: DuvidaFrequenteParams
  ): Promise<TResponseApi<DuvidaFrequentePage>> {
    return publicApi.get<
      TResponseApi<DuvidaFrequentePage>,
      TResponseApi<DuvidaFrequentePage>
    >(this.rota, { params });
  }
}
